// extracted by mini-css-extract-plugin
export var hideEditor = "_mv-2";
export var infoIcon = "_mv-3";
export var label = "_mv-1";
export var labelContainer = "_mv-0";
export var readonlyText = "_mv-4";